{
  "includedProducts": {
    "seatMeal": {
      "title": "Seat + Meal Combo"
    },
    "seatPriority": {
      "title": "Seat + Priority Combo"
    },
    "seatWifi": {
      "title": "Seat + Internet Combo"
    },
    "seatCabinBaggage": {
      "title": "Seat + Baggage Combo"
    }
  },
  "checkIn": {
    "confirmation": {
      "pdf_v2": {
        "buttonText": "Download (v2)"
      }
    }
  }
}
